import { render } from "./PaginatedTableComponent.vue?vue&type=template&id=62ede88a"
import script from "./PaginatedTableComponent.vue?vue&type=script&lang=js"
export * from "./PaginatedTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__